import { type ActionType, getType } from 'typesafe-actions';

import { RequestStatus } from '../../../../models';
import { actions } from '../actions';
import type ShortcutsState from '../ShortcutsState';

import INITIAL_STATE from './initialState';

export default (
  // eslint-disable-next-line @typescript-eslint/default-param-last -- conform to reducer signature
  state = INITIAL_STATE,
  action: ActionType<typeof actions>
): ShortcutsState => {
  switch (action.type) {
    case getType(actions.personalShortcutsRequested):
      return {
        ...state,
        personalShortcutsStatus: RequestStatus.Pending,
      };

    case getType(actions.personalShortcutsReceived): {
      return {
        ...state,
        personalShortcutsStatus: RequestStatus.Idle,
        personalShortcuts: action.payload,
      };
    }

    case getType(actions.personalShortcutsNotReceived):
      return {
        ...state,
        personalShortcutsStatus: RequestStatus.Idle,
        personalShortcuts: 'error',
      };

    default:
      return state;
  }
};
